<div class="grid-x">
  <div class="cell small-8"></div>
  <div class="cell small-4">
    <button class="button small margin-right" (click)="save()">SAVE</button>
    <button class="button small" (click)="addPoint()">Add Point</button>
  </div>
  <label class="cell small-12">
    Title
    <input type="text" [(ngModel)]="model.title" />
  </label>
  @for (point of model.mappings; track point; let idx = $index) {
    <div class="cell small-12">
      <h5>Point #{{idx+1}}</h5>
      <label class="cell small-12">
        Latitude (Context Location)
        <input type="text" [(ngModel)]="point.yContextLocation" />
      </label>
      <label class="cell small-12">
        Longitude (Context Location)
        <input type="text" [(ngModel)]="point.xContextLocation" />
      </label>
    </div>
  }
</div>
